module.exports = __webpack_public_path__ + "static/media/Olympic_logo.ce54fbae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Olympic_logo.svg
// module id = 229
// module chunks = 0